/**
 * TEST marketplace (sweet-listeners-test) enables demo sessions and the
 * last-4 18+ stand-in. Live hosts never count as TEST, even if the demo
 * flag was left on.
 */

const LIVE_HOSTS = new Set([
  'sweetlisteners.com',
  'www.sweetlisteners.com',
  'sweet-listeners.fly.dev',
]);

const hostFromUrl = raw => {
  if (typeof raw !== 'string' || !raw.trim()) {
    return '';
  }
  try {
    const value = raw.includes('://') ? raw.trim() : `https://${raw.trim()}`;
    return new URL(value).hostname.toLowerCase();
  } catch (e) {
    return '';
  }
};

const marketplaceHost = () =>
  hostFromUrl(process.env.REACT_APP_MARKETPLACE_ROOT_URL) ||
  hostFromUrl(process.env.REACT_APP_CANONICAL_ROOT_URL);

export const isLiveMarketplace = () => LIVE_HOSTS.has(marketplaceHost());

/**
 * @returns {boolean}
 */
export const isTestMarketplace = () => {
  if (isLiveMarketplace()) {
    return false;
  }
  return process.env.REACT_APP_ALLOW_DEMO_SESSIONS === 'true';
};

export default isTestMarketplace;
